module.exports = __webpack_public_path__ + "static/media/ic_opportunity_inactive.73b8ba23.svg";